import { LayoutDto, TableDto, TableTypeDto } from 'gleblu-socket-api';

import { toDto as toLayoutDto } from '../../../models/adapters/LayoutAdapter';
import LayoutFormData from '../../../pages/SettingsPage/Layout/LayoutTables/LayoutFormData';

export default function layoutFormDataToDtos(
  placeUuid: string,
  layoutUuid: string,
  layoutFormData: LayoutFormData
): {
  layoutDto: LayoutDto;
  tableDtos: TableDto[];
  tableTypeDtos: TableTypeDto[];
} {
  const { label, isOpen, type, tables } = layoutFormData;
  const layoutDto = toLayoutDto({ uuid: layoutUuid, placeUuid, label, isOpen, type });
  const tableDtos: TableDto[] = tables.map(({ tableUuid, tableTypeUuid, label: tableLabel }) => ({
    uuid: tableUuid,
    tableTypeUuid,
    label: tableLabel,
    layoutUuid,
  }));
  const tableTypeDtos: TableTypeDto[] = tables.map(({ tableUuid, tableTypeUuid, capacity }) => ({
    uuid: tableTypeUuid,
    tableUuid,
    capacity,
    layoutUuid,
  }));
  return { layoutDto, tableDtos, tableTypeDtos };
}
